
























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';
import IntegrationSettingsEdit from '@/components/Integrations/IntegrationSettingsEdit.vue';
import MicrosoftGoogleSettingsEdit from '@/components/Integrations/MicrosoftGoogleSettingsEdit.vue';
import IntegrationLogo from '@/components/Integrations/IntegrationLogo.vue';
import ListUtils from '@/lib/listUtils';
import XeroAuthButton from '@/components/Integrations/XeroAuthButton.vue';
import OutboundIntegrationLogList from '@/components/Integrations/OutboundIntegrationLogList.vue';
import PureProTestPanel from '@/components/Integrations/PureProTestPanel.vue';
import IntegrationSystemIdConstants from '@/models/Integrations/IntegrationSystemIdConstants';

@Component({
	name: 'Integration',
  	components: { IntegrationSettingsEdit, MicrosoftGoogleSettingsEdit, Alert, IntegrationLogo, XeroAuthButton, OutboundIntegrationLogList, PureProTestPanel }
})
export default class extends GiganautVue {
    IntegrationSystemIdConstants = IntegrationSystemIdConstants;
    
	beforeMount() {
		const integrationId = this.$route.params.integrationid;
		if (integrationId) {
            AgencySettingsModule.getIntegrationById(integrationId);
		}
  	}

	navigateToIntegrations() {
		this.$router.push({ name: PageNames.AgencyIntegrationSettings });
	}

    integrationDescription(systemId: string) {
        return ListUtils.integrationDescription(systemId);
    }
    integrationGiganautFeatures(systemId: string) {
        return ListUtils.integrationGiganautFeatures(systemId);
    }

  	get loading() {
		return AgencySettingsModule.loadingIntegrations;
  	}

	get integration() {
		return AgencySettingsModule.currentIntegration;
	}
  
  get isXeroConnected() {
    if (!this.integration || !this.integration.settings) return false;
    return this.integration.integrationSystemId === IntegrationSystemIdConstants.Xero &&
           this.integration.settings.some(s => s.key === 'Access Token' || s.key === 'Refresh Token');
  }

  get isMicrosoft365OrGoogle() {
    if (!this.integration) return false;
    return this.integration.integrationSystemId === IntegrationSystemIdConstants.Microsoft365 ||
           this.integration.integrationSystemId === IntegrationSystemIdConstants.GoogleWorkspace;
  }

  get isPurePro() {
    if (!this.integration) return false;
    return this.integration.integrationSystemId === IntegrationSystemIdConstants.PurePro;
  }

  get ssoEnabled() {
    if (!this.integration || !this.integration.settings) return false;
    const setting = this.integration.settings.find(s => s.key === 'sso_enabled');
    return setting ? setting.value === 'true' : false;
  }

  get mailboxSyncEnabled() {
    if (!this.integration || !this.integration.settings) return false;
    const setting = this.integration.settings.find(s => s.key === 'mailbox_sync_enabled');
    return setting ? setting.value === 'true' : false;
  }

  get ssoEmailDomains() {
    if (!this.integration || !this.integration.settings) return '';
    const setting = this.integration.settings.find(s => s.key === 'email_domain');
    return setting ? setting.value : '';
  }

  get ssoTenantId() {
    if (!this.integration || !this.integration.settings) return '';
    const setting = this.integration.settings.find(s => s.key === 'tenant_id');
    return setting ? setting.value : '';
  }

  get ssoConfigMissing() {
    if (!this.integration || !this.ssoEnabled) return false;
    // Check if required config is missing
    const isMicrosoft = this.integration.integrationSystemId === IntegrationSystemIdConstants.Microsoft365;
    if (isMicrosoft && !this.ssoTenantId) return true;
    if (!this.ssoEmailDomains) return true;
    return false;
  }
}
